export default __webpack_public_path__ + "611c4f58e5d6f0abae1a9b43ed76da28.png";